export default "__VITE_ASSET__D9fgXEok__"